/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { UserStore } from 'src/core/stores/UserStore';

export const authInfoMapper = ({
    id,
    name,
    email,
    photo,
    defaultTenantId
}: {
    id: string;
    name: string;
    email: string;
    photo: string;
    defaultTenantId: string;
}) => new UserStore(id, { email, name, principalId: id, photo, defaultTenantId });
